module.exports = __webpack_public_path__ + "assets/img/icon-h5.f2fa60bd.png";